/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2025-04-08 20:58:06 */

const Keys = {
  submit: 'submit',
  pickupStation: 'pickupStation',
  pickupDate: 'pickupDate',
  dropOffStation: 'dropOffStation',
  dropOffDate: 'dropOffDate',
  dropoffIsPickup: 'dropoffIsPickup',
  adults: 'adults',
  children: 'children',
  traveler: 'traveler',
  travelers: 'travelers'
}; export default Keys;